import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../../utils/SEO";

export default function BrokerageLicenseAnjouan (){

    return (
        <main className='main'>

            <SEO
                title="Anjouan FX License | Brokerage & Clearing License"
                description="Get an Anjouan forex, CFD & clearing house license. Fast, cost-effective setup for brokers under AOFA regulation in Comoros."
                keywords="Anjouan forex license, AOFA brokerage license, Comoros FX broker, Anjouan clearing house license, CFD license Anjouan, offshore brokerage Comoros, Anjouan investment dealer, prop trading license Anjouan"
                url="/brokerage-license-anjouan"
            />

            <IntroSection
                title="Brokerage/FX & Clearing House License – Anjouan (Comoros)"
                subtitle="Launch Your Brokerage with CRA Licensing"
                description =
                    "
                        Anjouan, part of the <b>Union of Comoros</b>, offers one of the most <b>cost-effective and startup-friendly solutions</b> for <b>forex brokerages and clearing houses</b>. Regulated by the <b>Anjouan Offshore Finance Authority (AOFA)</b>, its licensing framework covers <b>forex, CFDs, brokerage, and clearing operations</b>, making it ideal for both <b>new brokers</b> and <b>established firms seeking global reach</b>.
                    "
                badges={
                    [
                        "Forex & CFD Brokerage",
                        "Investment Dealer Services",
                        "Clearing House License",
                        "Prop Trading"
                    ]
                }
                buttonText="Request an Anjouan Brokerage/FX Proposa →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/brokerage-license-anjouan-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Anjouan?'
                        subtitle='Operating a brokerage without a license limits your growth and credibility. With a license, you gain:'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "No Capital Requirement",
                                            text: "Unlike Mauritius, Seychelles, or Cyprus, AOFA licenses require minimal initial capital."
                                        },
                                        {
                                            title: "Fast Approvals",
                                            text: "Licenses are typically issued within 4–8 weeks."
                                        },
                                        {
                                            title: "Affordable Setup",
                                            text: "One of the lowest licensing costs globally."
                                        },
                                        {
                                            title: "Operate Internationally",
                                            text: "AOFA licenses are designed for offshore and global business operations."
                                        },
                                        {
                                            title: "Crypto & Fintech Friendly",
                                            text: "Allows combining FX brokerage with crypto trading or digital clearing solutions."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="What the License Covers"
                        blocks={[
                            {
                                title: "Brokerage/FX License",
                                items:
                                    [
                                        {
                                            title: "Forex Brokerage Operations",
                                            text: "STP, ECN, and Market Maker models for forex trading."
                                        },
                                        {
                                            title: "CFDs & Derivatives Trading",
                                            text: "Trade indices, commodities, crypto CFDs, and stocks."
                                        },
                                        {
                                            title: "Investment Dealer Services",
                                            text: "Provide portfolio advisory and access to trading platforms."
                                        },
                                        {
                                            title: "Prop Trading Firms",
                                            text: "Run funded trader programs under a licensed structure."
                                        }
                                    ]
                            },
                            {
                                title: "Clearing House License",
                                items:
                                    [
                                        {
                                            title: "Trade Clearing & Settlement Services",
                                            text: "Provide clearing and settlement solutions for brokerage groups."
                                        },
                                        {
                                            title: "Liquidity Provision & Risk Management",
                                            text: "Offer liquidity and risk management services for forex and CFD platforms."
                                        },
                                        {
                                            title: "Internal Clearing for Broker Networks",
                                            text: "Streamline operations and ensure compliance across broker networks."
                                        },
                                        {
                                            title: "Hybrid FX + Crypto Clearing",
                                            text: "Operate multi-asset clearing services combining FX and cryptocurrency."
                                        }
                                    ]
                            },
                        ]}
                    />


                    <LocationTimeline
                        title="Benefits of Anjouan FX & Clearing License"
                        item={
                            [
                                {
                                    title: "Global Market Entry",
                                    text: "Easier onboarding with PSPs and liquidity providers for international operations."
                                },
                                {
                                    title: "Startup-Friendly",
                                    text: "Ideal licensing option for new forex brokers and fintech firms."
                                },
                                {
                                    title: "Access to MT4/MT5 White Labels",
                                    text: "Facilitates integration with MT4/MT5 platforms under licensed status."
                                },
                                {
                                    title: "Compliance-Oriented",
                                    text: "Supports AML/KYC frameworks adapted to your operational model."
                                },
                                {
                                    title: "Scalable",
                                    text: "Start with brokerage operations and expand to clearing house services."
                                }
                            ]
                        }
                    />



                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Planning",
                                    text: "Define whether to operate as a brokerage or clearing house model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Register an International Business Company (IBC) in Anjouan."
                                },
                                {
                                    title: "Compliance Documentation",
                                    text: "Prepare business plan, AML/KYC manuals, and risk management policies."
                                },
                                {
                                    title: "Application Filing",
                                    text: "Offshore Advisory submits the license application to AOFA."
                                },
                                {
                                    title: "Approval & License Issuance",
                                    text: "License is typically issued within 4–8 weeks."
                                }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                description: "(faster than Mauritius or Cyprus)",
                                duration: "4–8 weeks",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Cost",
                                description: "from USD 19,000–20,000+",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "None",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Renewals",
                                description: "very competitive compared to Seychelles or Belize.",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Authorized AOFA agent with brokerage & clearing license expertise" },
                                { text: "End-to-end service: incorporation, license filing, compliance, banking access" },
                                { text: "Partnerships with liquidity providers, MT4/MT5 white labels, and PSPs" },
                                { text: "Crypto & hybrid FX models fully supported" },
                                { text: "Transparent pricing & fast processing" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                             Ready to launch your forex brokerage or clearing house?
                             "
                         description=
                             "
                             Anjouan offers one of the <b>fastest and most affordable offshore licenses</b> with <b>no capital requirements</b>.
                             "
                         buttonText='Book an Anjouan Brokerage & Clearing License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is there a capital requirement for FX/Clearing licenses in Anjouan?",
        content: [
            { type: "answer", text: "No — AOFA does not require minimum paid-up capital." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Typically 4–8 weeks, among the fastest worldwide." },
        ],
    },
    {
        question: "Can I integrate MT4/MT5 under this license?",
        content: [
            { type: "answer", text: "Yes — Offshore Advisory assists with white-label and full platform setups." },
        ],
    },
    {
        question: "Can I operate a clearing house alongside brokerage?",
        content: [
            { type: "answer", text: "Yes — AOFA allows both brokerage and clearing operations under the same structure." },
        ],
    },
    {
        question: "Is crypto trading supported?",
        content: [
            { type: "answer", text: "Yes — you can combine forex + crypto brokerage or operate a crypto clearing house." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We obtained a brokerage license in Anjouan in 5 weeks. Offshore Advisory helped us with liquidity providers and PSP access.",
            author: "James L.",
            role: "FX Broker CEO"
        },
        {
            quote: "Our group set up a clearing house under AOFA licensing. Offshore Advisory structured the compliance and integration flawlessly.",
            author: "Maria T.",
            role: "Trading Firm COO"
        }
    ]
;